export default __webpack_public_path__ + "static/media/CROWNIMAGE.8772baf0.jpeg";